import type { SavedPrompt } from '../types/preferences';

export const sortSavedPromptsByOrder = (prompts: SavedPrompt[]): SavedPrompt[] => (
  [...prompts].sort((left, right) => (
    left.sort_order - right.sort_order || left.title.localeCompare(right.title)
  ))
);